export class DemandProductData implements IDemandProductData {
    public description = '';
    public manufacturer = '';
    public manufacturerArticleNumber = '';
    public supplierArticleNumber = '';
    public name = '';
    public numberOfContentUnitsPerOrderUnit = 1;
    public contentUnit = 'C62';
    public customerProductNumber = '';

    public static fromDto(dto: IDemandProductData): DemandProductData {
        const data = new DemandProductData();
        Object.assign(data, dto);

        return data;
    }
}

export interface IDemandProductData {
    name: string;
    description: string;
    customerProductNumber: string;
    manufacturer: string;
    manufacturerArticleNumber: string;
    supplierArticleNumber: string;
    numberOfContentUnitsPerOrderUnit: number;
    contentUnit: string;
}
